/**
 * Writing Styles - Simplified Chinese Localization
 */

export default {
    writingStyles: {
        title: '撰写风格',
        description: '管理您的专利撰写风格',

        // Actions
        actions: {
            create: '创建风格',
            edit: '编辑',
            delete: '删除',
            preview: '预览',
            duplicate: '复制',
            export: '导出',
            favorite: '添加到收藏',
            unfavorite: '取消收藏',
            selectFile: '选择文件',
            uploadFile: '上传文件',
            download: '下载',
            cancel: '取消',
            save: '保存',
            saving: '保存中...',
            confirm: '确认',
            viewAll: '查看全部',
            collapseAll: '全部折叠',
            expandAll: '全部展开',
            sort: '排序',
            more: '更多',
        },

        // Tabs
        tabs: {
            all: '全部',
            public: '公开',
            private: '私有',
            favorites: '收藏',
        },

        // Filters
        filters: {
            region: '地区',
            allRegions: '所有地区',
            sourceType: '来源类型',
            allSources: '所有来源',
            search: '搜索风格...',
        },

        // View Modes
        viewMode: {
            grid: '网格视图',
            list: '列表视图',
        },

        // Categories
        categories: {
            all: '全部分类',
            public: '公开',
            private: '私有',
            system: '系统预设',
            custom: '用户自定义',
            SYSTEM: '系统预设',
            CUSTOM: '用户自定义',
            favorites: '收藏',
            FAVORITES: '收藏',
        },

        // Source Types
        sourceTypes: {
            reference: '专利与文档',
            upload: '文件上传',
            manual: '手动输入',
            pdf: 'PDF 上传',
            word: 'Word 上传',
            patent_number: '专利号',
            patentNumber: '专利号',
        },

        // Regions
        regions: {
            all: '所有地区',
            USPTO: '美国',
            us: '美国',
            CNIPA: '中国',
            cn: '中国',
            EPO: '欧洲',
            ep: '欧洲',
            JPO: '日本',
            jp: '日本',
            KIPO: '韩国',
            kr: '韩国',
            WIPO: 'WIPO',
            wipo: 'WIPO',
            PCT: '国际 (PCT)',
        },

        // Sections
        sections: {
            title: '标题',
            titlePlaceholder: '请输入专利标题',
            abstract: '摘要',
            abstractPlaceholder: '请输入专利摘要',
            claims: '权利要求',
            claimsPlaceholder: '请输入权利要求',
            technicalField: '技术领域',
            technicalFieldPlaceholder: '请输入技术领域',
            background: '背景技术',
            backgroundPlaceholder: '请输入背景技术',
            summary: '发明内容',
            summaryPlaceholder: '请输入发明内容',
            drawings: '附图说明',
            drawingsPlaceholder: '请输入附图说明',
            detailedDescription: '具体实施例',
            detailedDescriptionPlaceholder: '请输入具体实施例',
        },

        // Dialog
        dialog: {
            createStyle: '创建撰写风格',
            editStyle: '编辑撰写风格',
            createStyleDesc: '从已公开的专利中学习，构建您的撰写风格',
            styleName: '风格名称',
            styleNamePlaceholder: '输入风格的描述性名称',
            description: '描述',
            descriptionPlaceholder: '输入简短描述（可选）',
            region: '地区',
            category: '分类',
            visibility: '可见性',
            public: '团队可见',
            private: '仅自己',
            publicDesc: '对所有团队成员可见',
            privateDesc: '仅对您可见',
            sourceType: '来源类型',
            manualDesc: '手动输入每个部分',
            pdfDesc: '上传 PDF 文件提取内容',
            wordDesc: '上传 Word 文档提取内容',
            patentNumberDesc: '从专利号获取内容',
            uploadFile: '参考文档',
            dragDropOrClick: '点击或拖拽文件到此处上传',
            pdfWordSupport: '支持 PDF 和 Word 文档（最大 50MB）',
            pdfOnly: '仅支持 PDF 文件（最大 50MB）',
            wordOnly: '仅支持 Word 文档（最大 50MB）',
            selectFile: '选择文件',
            uploading: '上传中...',
            patentNumber: '参考专利',
            patentNumberPlaceholder: '例如：US1234567A、CN201910123456A',
            fetch: '获取',
            sections: '专利章节',
            sectionsHint: '配置每个章节的内容',
            expandAll: '展开全部',
            collapseAll: '收起全部',
            sectionPlaceholder: '输入此章节的内容...',
            required: '必填',
            chars: '字符',
            cancel: '取消',
            create: '创建风格',
            save: '保存更改',
            saveChanges: '保存更改',
            saving: '保存中...',

            // Level selection (Super Admin only)
            level: '可见性',
            adminOnly: '仅管理员',
            systemLevel: '系统级',
            userLevel: '用户级',
            systemLevelDesc: '对所有用户可见',
            userLevelDesc: '仅自己可见',

            // Visibility Dialog
            changeVisibility: '更改可见性权限',
            visibilityDescription: '选择此撰写风格的可见性设置。私有风格仅对您可见，公开风格对团队所有成员可见。',
            teamVisible: '团队可见',
            teamVisibleDesc: '对团队所有成员可见',
            privateVisible: '仅自己',
            privateVisibleDesc: '仅对创建者可见',
            changeToPublicWarning: '更改为团队可见后，您团队的所有成员都可以查看和使用此风格。',
            changeToPrivateWarning: '更改为仅自己可见后，只有您可以查看和使用此风格。',
        },

        // Create Dialog (legacy - for backward compatibility)
        createDialog: {
            title: '创建撰写风格',
            editTitle: '编辑撰写风格',
            basicInfo: '基本信息',
            name: '名称',
            namePlaceholder: '输入风格名称',
            nameRequired: '名称为必填项',
            description: '描述',
            descriptionPlaceholder: '输入风格描述（可选）',
            region: '地区',
            regionPlaceholder: '选择地区',
            regionRequired: '地区为必填项',
            category: '分类',
            categoryPlaceholder: '选择分类',
            tags: '标签',
            tagsPlaceholder: '添加标签（按回车）',

            sourceMethod: '来源方式',
            selectSourceMethod: '选择创建风格的方式',
            manualInput: '手动输入',
            manualInputDesc: '手动输入每个部分的内容',
            uploadPdf: '上传 PDF',
            uploadPdfDesc: '上传 PDF 文件并提取内容',
            uploadWord: '上传 Word',
            uploadWordDesc: '上传 Word 文档并提取内容',
            patentNumber: '专利号',
            patentNumberDesc: '从专利号获取内容',

            patentNumberLabel: '专利号',
            patentNumberPlaceholder: '输入专利号（如：US1234567A）',
            patentNumberFetch: '获取专利',
            patentNumberFetching: '获取中...',

            fileUpload: '文件上传',
            fileUploadDrag: '点击或拖拽文件到此区域上传',
            fileUploadHint: '支持 PDF 和 Word 文件，最大 50MB',
            fileUploading: '上传中...',
            fileProcessing: '处理文件中...',
            fileProcessed: '文件处理成功',

            sectionContent: '章节内容',
            sectionContentDesc: '编辑每个章节的内容',
            sectionRequired: '必填',
            sectionOptional: '可选',
            sectionPlaceholder: '输入 {section} 的内容',
            sectionEmpty: '无内容',
        },

        // Preview Dialog
        preview: {
            title: '预览撰写风格',
            loading: '加载预览中...',
            wordDocument: 'Word 文档',
            patentNumber: '专利号',
            noContent: '暂无内容',
            resetZoom: '重置缩放',
            sections: '章节',
            usageCount: '使用次数',
            lastUpdated: '最后更新',
        },
        previewDialog: {
            title: '预览撰写风格',
            loading: '加载预览中...',
            sourceInfo: '来源信息',
            sourceType: '来源类型',
            fileName: '文件名',
            patentNumber: '专利号',
            fileSize: '文件大小',
            uploadDate: '上传日期',
            openFile: '打开文件',
            sections: '章节',
        },

        // Empty States
        empty: {
            noStyles: '暂无撰写风格',
            createFirstStyle: '创建您的第一个撰写风格以开始使用',
            noResults: '未找到风格',
            tryDifferentFilters: '尝试调整筛选条件或搜索词',
            noStylesFound: '未找到撰写风格',
        },
        emptyState: {
            title: '暂无撰写风格',
            description: '创建您的第一个撰写风格以开始使用',
            createButton: '创建风格',
            noResults: '未找到风格',
            noResultsDesc: '尝试调整筛选条件或搜索词',
        },

        // Stats
        stats: {
            total: '总风格数',
            public: '公开风格',
            private: '私有风格',
            system: '系统风格', // ✅ 新增
            custom: '自定义风格', // ✅ 新增
            favorites: '收藏风格',
        },

        // Delete Confirmation
        delete: {
            title: '删除撰写风格',
            message: '确定要删除 "{name}" 吗？',
            confirm: '删除',
            cancel: '取消',
        },

        // Editor
        editor: {
            createTitle: '新建撰写风格',
            editTitle: '编辑撰写风格',
            basicInfo: '基本信息',
            sourceType: '来源类型',
            referenceDoc: '参考文档',
            manualInput: '手动输入',
            patentNumber: '专利号',
            patentNumberPlaceholder: '例如：US1234567A、CN201910123456A',
            fetch: '获取',
            uploadFile: '上传文件',
            uploadTitle: '点击或拖拽专利文档到此处上传',
            uploadHint: '上传专利文档作为撰写风格参考 — 支持 PDF 和 Word（最大 50MB）',
            fileProcessing: '解析中...',
            fileCompleted: '解析完成',
            fileFailed: '解析失败',
            loadingPatentData: '正在加载专利信息...',
            patentDataLoaded: '专利信息加载成功',
            searchFailed: '搜索失败',
            patentDataLoadSuccess: '专利信息加载成功',
            patentDataLoadFailed: '加载专利信息失败',
            fileUploadedHint: '已上传文件，无法输入专利号',
            patentNumberEnteredHint: '已输入专利号，无法上传文件',
            generateStyle: '生成风格',
            saveStyle: '保存风格',
            generateSuccess: '风格生成成功',
            generateFailed: '风格生成失败',
            saveSuccess: '风格保存成功',
            saveFailed: '风格保存失败',
            manualEditMode: '已进入手动编辑模式',
            manualInputHint: '选择手动输入后，您可以直接在右侧编辑器中编写风格内容',
            emptyTitle: '开始创建您的撰写风格',
            emptyDescription: '填写左侧的基本信息，选择参考文档或手动输入，然后点击"生成风格"按钮',
            sectionsTitle: '编辑撰写风格内容',
            sectionsHint: '请填写各个部分的内容。标记为必填的部分必须填写。',
            previewTitle: '风格内容预览',
            patentTitle: '标题',
            patentAbstract: '摘要',
            patentClaims: '权利要求',
            patentDescription: '说明书',
            autoCreate: '分析并创建',
        },

        // Messages
        messages: {
            createSuccess: '撰写风格创建成功',
            createError: '创建撰写风格失败',
            updateSuccess: '撰写风格更新成功',
            updateError: '更新撰写风格失败',
            saveError: '保存撰写风格失败',
            deleteSuccess: '撰写风格删除成功',
            deleteError: '删除撰写风格失败',
            duplicateSuccess: '撰写风格复制成功',
            duplicateError: '复制撰写风格失败',
            favoriteSuccess: '已添加到收藏',
            unfavoriteSuccess: '已取消收藏',
            favoriteError: '收藏操作失败',
            toggleFavoriteError: '收藏操作失败',
            loadError: '加载撰写风格失败',
            fetchDetailError: '获取风格详情失败',
            visibilityChangeSuccess: '可见性权限更改成功',
            visibilityChangeError: '更改可见性权限失败',
            systemStyleNotEditable: '系统预设风格不可编辑，您可以复制后修改',
            systemStyleReadOnly: '系统风格为只读，无法编辑',
            fileUploadSuccess: '文件上传成功',
            fileUploadError: '文件上传失败',
            patentFetchSuccess: '专利信息获取成功',
            patentFetchError: '获取专利信息失败',
            validationError: '请填写所有必填项',
            sectionValidationError: '请填写所有必填章节',
        },

        // Card Info
        card: {
            usedTimes: '使用 {count} 次',
            lastModified: '修改于 {time}',
            createdBy: '创建者 {name}',
        },

        // Patent Search Dialog
        patentSearch: {
            title: '检索专利',
            placeholder: '输入专利号，如：US11739015B2、CN201910123456A',
            search: '检索',
            hint: '输入专利号检索 — AI 将分析其撰写模式，构建您的风格',
            hintBatch: '支持批量检索：多个专利号可用逗号、分号、空格或换行分隔',
            searching: '检索中...',
            noResults: '未找到相关专利',
            searchSuccess: '前{count} 篇相关专利',
            searchFailed: '检索失败，请稍后重试',
            batchSearching: '正在批量检索 {count} 个专利...',
            batchSearchSuccess: '批量检索完成：成功 {success} 个，失败 {failed} 个，共找到 {total} 个专利',
            selectedCount: '已选择 {count} 个专利',
            selectAtLeastOne: '请至少选择一个专利',
            loadDetailsFailed: '加载专利详情失败',
            enterPatentNumber: '请输入专利号',
        },
    },
};
